export default "__VITE_ASSET__DtST19qL__";